<template>
  <div style="width: 100%">
    <v-row
      v-if="competencias.length > 0"
      dense
    >
      <v-col>
        <v-row
          id="grafico-barras"
          class="mb-4"
          no-gutters
        >
          <v-col>
            <bar-chart
              :categorias="[]"
              :dados="dadosBarChart"
              :fonte="`Fonte: Sistema Desenvolva, ${anoMapeamento}`"
              :legenda="legendaBarChart"
              :titulo="tituloBarChart"
              :tooltip="tooltipBarChart"
              class="chart"
              descricao-eixo-y="Quantidade"
            />
          </v-col>
        </v-row>
        <v-row
          v-if="competencias.length > 0"
          id="grafico-pizza"
          no-gutters
        >
          <v-col>
            <pie-chart
              :dados="dadosPieChart"
              :fonte="`Fonte: Sistema Desenvolva, ${anoMapeamento}`"
              :titulo="tituloPieChart"
              class="chart"
            />
          </v-col>
        </v-row>
        <v-row
          v-if="totalCompetenciasInseridas > 0"
          class="justify-center"
        >
          <v-radio-group
            v-model="visualizacaoCompetencias"
            row
          >
            <v-radio
              label="Todas"
              value="TODAS"
            />
            <v-radio
              label="Gerais"
              value="GERAIS"
            />
            <v-radio
              label="Inseridas"
              value="INSERIDAS"
            />
          </v-radio-group>
        </v-row>
        <v-row>
          <v-col>
            <app-title texto="RESULTADOS" />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <app-sort v-model="opcoes" />
          </v-col>
          <v-spacer />
          <v-col>
            <app-search v-model="opcoes" />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-data-table
              :headers="headers"
              :items="competencias"
              :search="opcoes.pesquisa"
              :sort-by="opcoes.ordenarPor"
              :sort-desc="opcoes.decrescente"
              align-content-space-between
              class="elevation-0"
              disable-pagination
              hide-default-footer
            >
              <template v-slot:[`item.numero`]="{ index }">
                {{ index + 1 }}
              </template>
              <template v-slot:[`item.competenciaTecnica.nome`]="{ item }">
                <span
                  :class="
                    item.competenciaTecnica.unidades.length > 0
                      ? 'grey-text'
                      : 'secondary--text'
                  "
                >
                  {{ item.competenciaTecnica.nome }}
                </span>
              </template>
              <template v-slot:[`item.competenciaTecnica.tipo`]="{ item }">
                <span
                  :class="
                    item.competenciaTecnica.unidades.length > 0
                      ? 'grey-text'
                      : 'secondary--text'
                  "
                >
                  {{ item.competenciaTecnica.tipo }}
                </span>
              </template>
              <template v-slot:[`body.append`]>
                <tr>
                  <td
                    align="center"
                    colspan="3"
                  >
                    <strong
                      class="subtitle-2 grey--text text--darken-2"
                    >TOTAL</strong>
                  </td>
                  <td align="center">
                    <strong>{{ totalCompetencias }}</strong>
                  </td>
                </tr>
                <v-divider />
              </template>
            </v-data-table>
          </v-col>
        </v-row>
        <!-- Relatório PDF -->
        <v-row
          class="justify-end mb-1"
        >
          <v-tooltip
            max-width="400"
            top
          >
            <template v-slot:activator="{ on }">
              <v-btn
                color="success"
                @click="getRelatorio()"
                v-on="on"
              >
                <v-icon>get_app</v-icon>
                BAIXAR PDF
              </v-btn>
            </template>
            <span>Clique para baixar o relatório dos dados em formato PDF.</span>
          </v-tooltip>
        </v-row>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col>
        <app-alert
          icon="info"
          message="Não há competências técnicas consolidadas na(s) unidade(s)."
          type="info"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { sum } from 'mathjs';
import BarChart from '@/components/chart/BarChart';
import PieChart from '@/components/chart/PieChart';
import AppAlert from '@/components/core/AppAlert';
import AppTitle from '@/components/core/AppTitle';
import AppSort from '@/components/core/AppSort';
import AppSearch from '@/components/core/AppSearch';
import { generatePDF, getCanvas } from '@/modules/relatorioPDF';

export default {
  name: 'MonitoramentoCompetenciaTecnica',

  components: {
    BarChart,
    PieChart,
    AppAlert,
    AppTitle,
    AppSort,
    AppSearch,
  },

  props: {
    competencias: {
      type: Array,
      required: false,
      default: () => [],
    },
    unidade: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    mapeamento: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      headers: [
        {
          text: 'Nº',
          value: 'numero',
          width: '5',
          sortable: false,
        },
        { text: 'COMPETÊNCIA', value: 'competenciaTecnica.nomeAtual', sortable: false },
        { text: 'TIPO', value: 'competenciaTecnica.tipo', sortable: false },
        {
          text: 'QUANTIDADE',
          value: 'total',
          align: 'center',
          sortable: false,
        },
      ],
      opcoes: {
        pesquisa: '',
        decrescente: false,
        ordenarPor: 'total',
        selecionado: { id: 'total', descricao: 'Quantidade' },
        lista: [
          { id: 'competenciaTecnica.nomeAtual', descricao: 'Competência' },
          { id: 'competenciaTecnica.unidades.length', descricao: 'Tipo' },
          { id: 'total', descricao: 'Quantidade' },
        ],
      },
      visualizacaoCompetencias: 'TODAS',
      legendaBarChart:
        '<span style="color:#348ECA;margin-right:30px">Competências Técnicas Gerais</span>'
        + '<span style="color:grey">Competências Técnicas Inseridas</span>',
      tooltipBarChart: {
        headerFormat: '<span style="color:{point.color};padding:2px;"><b>{point.key}</b></span><table>',
        pointFormat:
          '<tr>'
          + '<td style="padding:0">Quantidade: </td>'
          + '<td style="padding:2px;text-align:right"><span>{point.y}</span></td>'
          + '</tr>',
        footerFormat: '</table>',
      },
    };
  },

  computed: {
    anoMapeamento() {
      return this.mapeamento.ano ? this.mapeamento.ano : '';
    },
    dadosBarChart() {
      return [
        {
          name: 'Quantidade',
          dataSorting: {
            enabled: true,
            sortKey: 'y',
          },
          data: this.competencias.map((c) => {
            if (c.competenciaTecnica.unidades.length === 0) {
              return { y: c.total, name: c.competenciaTecnica.nomeAtual, color: '#348ECA' };
            }
            return { y: c.total, name: c.competenciaTecnica.nomeAtual, color: 'grey' };
          }),
          color: '#ffffff',
        },
      ];
    },
    dadosPieChart() {
      if (this.competencias.length > 0) {
        let competencias;
        switch (this.visualizacaoCompetencias) {
          case 'GERAIS':
            competencias = this.competencias.filter((c) => c.competenciaTecnica.unidades.length === 0);
            break;
          case 'INSERIDAS':
            competencias = this.competencias.filter((c) => c.competenciaTecnica.unidades.length > 0);
            break;
          default:
            competencias = this.competencias;
        }
        return [
          {
            name: 'Competências Técnicas',
            data: competencias
              .map((c) => ({ name: c.competenciaTecnica.nomeAtual, y: c.total }))
              .sort((a, b) => {
                if (a.y > b.y) {
                  return -1;
                }
                if (a.y < b.y) {
                  return 1;
                }
                return 0;
              }),
          },
        ];
      }
      return [];
    },
    tituloBarChart() {
      if (this.unidade) {
        return 'Monitoramento de Competências Técnicas';
      }
      return 'Monitoramento Geral de Competências Técnicas';
    },
    tituloPieChart() {
      switch (this.visualizacaoCompetencias) {
        case 'GERAIS':
          return 'Competências Técnicas Gerais';
        case 'INSERIDAS':
          return 'Competências Técnicas Inseridas';
        default:
          return 'Competências Técnicas';
      }
    },
    totalCompetencias() {
      return sum(this.competencias.map((c) => c.total));
    },
    totalCompetenciasInseridas() {
      return this.competencias.filter((c) => c.competenciaTecnica.tipo === 'INSERIDA').length;
    },
  },

  methods: {
    async getRelatorio() {
      const documento = {
        nome: `relatorio-monitoramento-mapeamento-${this.unidade.sigla ? 'unidade' : 'geral'}-competencia-tecnica`,
        cabecalho: {
          titulo: `Relatório do Mapeamento Técnico ${this.unidade.sigla ? 'POR UNIDADE' : 'GERAL'}`,
          itens: [
            'Tipo de monitoramento: Competências Técnicas',
            this.unidade.sigla ? `Unidade: ${this.unidade.sigla}` : '',
            `Mapeamento: ${this.mapeamento.nome}`,
          ],
        },
        blocos: [
          {
            titulo: 'GRÁFICOS',
            subtitulo: 'MONITORAMENTO DE COMPETÊNCIAS TÉCNICAS',
            itens: [
              { tipo: 'imagem', valor: await getCanvas('#grafico-barras') },
            ],
          },
          {
            titulo: '',
            subtitulo: 'COMPETÊNCIAS TÉCNICAS',
            itens: [
              { tipo: 'imagem', valor: await getCanvas('#grafico-pizza'), altura: 60 },
            ],
          },
          {
            titulo: 'RESULTADOS',
            subtitulo: '',
            itens: [{
              tipo: 'tabela',
              valor: {
                colunas: [
                  'COMPETÊNCIA',
                  'TIPO',
                  'QUANTIDADE',
                ],
                linhas: this.competencias.map((c) => [
                  c.competenciaTecnica.nomeAtual,
                  c.competenciaTecnica.tipo,
                  c.total,
                ]),
                rodape: ['TOTAL', '', this.totalCompetencias],
              },
            }],
          },
        ],
      };
      generatePDF(documento);
    },
  },
};
</script>

<style scoped>
.chart {
  width: 100%;
  max-height: 400px;
  font-family: Roboto, sans-serif;
}
</style>
